import { render, staticRenderFns } from "./LiveBroadcastDetail.vue?vue&type=template&id=5468c709&"
import script from "./LiveBroadcastDetail.vue?vue&type=script&lang=js&"
export * from "./LiveBroadcastDetail.vue?vue&type=script&lang=js&"
import style0 from "./LiveBroadcastDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports